import { APIClient } from '../api_helper';
import * as url from './url_helper';
import qs from 'qs';
import config from '../../config';

const WATER_RIGHTS_BASE = config.api.REACT_APP_SPED_WATER_RIGHTS_API_URL;

const apiClient = new APIClient(WATER_RIGHTS_BASE);

// Helper function to stringify query parameters
const stringifyParams = params =>
	qs.stringify(params, {
		encodeValuesOnly: true,
	});

// Get utm zone list query (for remote operations)
export const getUtmZoneListQueryApi = (params) => {
	return apiClient.get(`${url.GET_UTM_ZONE_QUERY}?${stringifyParams(params)}`);
};

// Get utm zone list (with default filters)
export const getUtmZoneListApi = () => {
	const filters = {
		filters: {
			disable: {
				$eq: false,
			},
		},
		sort: [{ field: 'name', dir: 'asc' }],
	};

	const queryString = qs.stringify(filters, {
		encodeValuesOnly: true,
	});

	return apiClient.get(`${url.GET_UTM_ZONES}?${queryString}`);
};

// Get utm zone by id
export const getUtmZoneApi = (id) => {
	return apiClient.get(`${url.GET_UTM_ZONE}${id}`);
};

// Add new utm zone
export const addNewUtmZoneApi = (utmZone) => {
	return apiClient.create(url.POST_UTM_ZONE, utmZone);
};

// Update utm zone
export const updateUtmZoneApi = (utmZone) => {
	return apiClient.put(`${url.PUT_UTM_ZONE}${utmZone._id}`, utmZone);
};

// Delete utm zone
export const deleteUtmZoneApi = (utmZone) => {
	return apiClient.delete(`${url.DELETE_UTM_ZONE}${utmZone._id}`);
};

// Check if utm zone exists
export const checkUtmZoneExistsApi = async (name) => {
	try {
		const filters = {
			filters: {
				name: {
					$eq: name,
				},
			},
		};

		const queryString = qs.stringify(filters, {
			encodeValuesOnly: true,
		});

		const response = await apiClient.get(`${url.CHECK_UTM_ZONE_EXISTS}?${queryString}`);
		const data = response.data || response;

		return {
			exists: data.data && data.data.length > 0,
		};
	} catch (error) {
		console.error('Error checking utm zone exists:', error);
		return {
			exists: false,
		};
	}
};
